export const DETAILS_TAGS = [
  { tag: "O9" },
  { tag: "O10" },
  { tag: "T29" },
  { tag: "T26" },
  { tag: "T31" },
  { tag: "P47" },
  { tag: "T32" },
  { tag: "T33" },
  { tag: "T34" },
  { tag: "T35" },
  { tag: "T51" },
  //for calculation
  { tag: "P1" },
  { tag: "P2" },
  { tag: "P5" },
  { tag: "P6" },
  { tag: "P8" },
  // for phase1 update
  { tag: "T7"},
  { tag: "T9"},
  { tag: "P46"},
  { tag: "T65"},
  { tag: "T66"},
  { tag: "T61"},
  { tag: "T62"},
  { tag: "T63"},
  { tag: "T64"}
];
